import { render, staticRenderFns } from "./FolderContent.vue?vue&type=template&id=d2029866&scoped=true&"
import script from "./FolderContent.vue?vue&type=script&lang=js&"
export * from "./FolderContent.vue?vue&type=script&lang=js&"
import style0 from "./FolderContent.vue?vue&type=style&index=0&id=d2029866&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2029866",
  null
  
)

export default component.exports